// @flow

import { css } from 'styled-components';
import media from '../../../helpers/media';
import { breakpointKeys } from '../../../helpers/breakpoints';
import type { BreakpointData } from '../../row/types';

const spread = css`
  background-color: inherit;
  content: '';
  display: block;
  height: 100%;
  right: 100%;
  position: absolute;
  top: 0;
  width: 50vw;
  z-index: 0;
`;

const leftSpread = css`
  &::before {
    ${spread}
    right: 100%;
  }
`;

const rightSpread = css`
  &::after {
    ${spread}
    left: 100%;
  }
`;

const leftReset = css`
  &::before {
    display: none;
  }
`;

const rightReset = css`
  &::after {
    display: none;
  }
`;

/**
 * Set the spread style when needed and reset it if not
 */
export const getColumnSpread = (responsiveData: BreakpointData) => css`
  ${(responsiveData.default.hasLeft && leftSpread) || leftReset}
  ${(responsiveData.default.hasRight && rightSpread) || rightReset}
  ${breakpointKeys.map(breakpoint => media[breakpoint](css`
    ${(responsiveData[breakpoint].hasLeft && leftSpread) || leftReset}
    ${(responsiveData[breakpoint].hasRight && rightSpread) || rightReset}
  `))};
`;

export default null;
